import { SVGProps, Ref, forwardRef } from 'react';

export const BricksFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M4.646 11.6c1.25 0 1.876 0 2.265.322s.389.84.389 1.878 0 1.556-.389 1.878S5.897 16 4.646 16H2.654c-1.25 0-1.877 0-2.265-.322C0 15.355 0 14.837 0 13.8s0-1.556.389-1.878c.388-.322 1.014-.322 2.265-.322z"
                fill="currentColor"
            />
            <path
                d="M13.346 11.6c1.25 0 1.877 0 2.265.322.39.322.389.84.389 1.878s0 1.555-.389 1.878c-.388.322-1.014.322-2.265.322h-1.992c-1.25 0-1.876 0-2.265-.322S8.7 14.837 8.7 13.8s0-1.556.389-1.878 1.014-.322 2.265-.322z"
                fill="currentColor"
            />
            <path
                d="M9.009 5.8c1.268 0 1.903 0 2.297.322s.394.84.394 1.878 0 1.556-.394 1.878-1.029.322-2.297.322H6.99c-1.268 0-1.903 0-2.297-.322S4.3 9.038 4.3 8s0-1.556.394-1.878S5.723 5.8 6.991 5.8z"
                fill="currentColor"
            />
            <path
                d="M4.646 0c1.25 0 1.876 0 2.265.322S7.3 1.163 7.3 2.2s0 1.556-.389 1.878-1.014.322-2.265.322H2.654c-1.25 0-1.877 0-2.265-.322C-.001 3.756 0 3.238 0 2.2S0 .644.389.322C.777 0 1.403 0 2.654 0z"
                fill="currentColor"
            />
            <path
                d="M13.346 0c1.25 0 1.877 0 2.265.322S16 1.163 16 2.2s0 1.556-.389 1.878c-.388.322-1.014.322-2.265.322h-1.992c-1.25 0-1.876 0-2.265-.322S8.7 3.238 8.7 2.2 8.7.644 9.09.322 10.103 0 11.354 0z"
                fill="currentColor"
            />
        </g>
    </svg>
));
BricksFilledSize16Glyph.displayName = 'BricksFilledSize16Glyph';
